module.exports = __webpack_public_path__ + "static/media/login_1.be0c9f89.jpg";